import script from "./TutorialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialsPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorialsPage.vue?vue&type=style&index=0&id=71701756&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71701756"]])

export default __exports__